import QuoteLoading from 'components/quoteLoading';
import { PrivatePreSignup } from 'features/privateHealthPreSignup/models';
import { CustomComponentProps } from 'models/questionnaireFramework';

export const CalculatingPrice = ({
  onSubmitValue,
}: CustomComponentProps<PrivatePreSignup>) => {
  return <QuoteLoading onFinished={() => onSubmitValue(true)} />;
};
